import React, { createRef, useEffect, useRef, useState } from 'react'
import { useQuery } from '@apollo/client'
import {
  GET_ALL_CURRENT_BILL_DETAILS,
  GET_ALL_PACKAGE_AND_FEATURES_LIST
} from '../../graphql/query'
import AccountActionMenu from './AccountActionMenu'
import LoadingSpinner from '../../components/LoadingSpinner'
import ReactModal from 'react-modal'
import PackageExpiryNotificationModal from './PackageExpiryNotificationModal'

interface DataType {
  key: React.Key
  name: string
  email: string
  planName: string
  amount: string
  discount: string
  status: string
  expiryDate: string
  notificationStatus: number
  lastNotificationDate: string
  invoice: number
  bgId: number
  package: number
  currency: string
  paymentMode: string
  gateway: string
}

const Account: React.FC = () => {
  const [searchInput, setSearchInput] = useState<string>('')
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null)
  const [selectedClientPackage, setSelectedClientPackage] = useState<string | null>(null)
  const [packageData, setPackageData] = useState<any[]>([])
  const accountActionDropdownMenuRefs = useRef<any[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const accountPerPage = 10
  const accountPerPageOffset = (currentPage - 1) * accountPerPage
  const [isModalOpen, setIsModalOpen] = useState<any>(false)
  const [selectedAccount, setSelectedAccount] = useState<any>(null)
  const { error, loading, data } = useQuery(GET_ALL_PACKAGE_AND_FEATURES_LIST, {
    context: {
      headers: {
        'access-control-allow-methods': 'Accounts'
      }
    }
  })

  const {
    data: data1,
    loading: loading1,
    error: error1,
    refetch
  } = useQuery(GET_ALL_CURRENT_BILL_DETAILS, {
    variables: {
      input: {
        limit: accountPerPage,
        offset: accountPerPageOffset
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Accounts'
      }
    }
  })

  const customModalStyles: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029',
      zIndex: '999'
    }
  }

  const openModal = (account: any) => {
    setSelectedAccount(account)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }
  console.log('check')

  const handleStatusFilterChange = (value: string | null) => {
    setSelectedStatus(value)
  }

  const handleClientPackageChange = (value: string | null) => {
    console.log(value)
    setSelectedClientPackage(value)
  }

  useEffect(() => {
    const variables: any = {
      input: {
        limit: 10,
        offset: 0
      }
    }

    if (selectedStatus && selectedStatus !== 'Select') {
      variables.input.packageStatus = selectedStatus
    }

    if (selectedClientPackage && selectedClientPackage !== 'Select') {
      variables.input.packageName = selectedClientPackage
    }

    if (searchInput) {
      variables.input.invoiceNumber = searchInput
    }

    refetch(variables)
  }, [selectedStatus, selectedClientPackage, searchInput, refetch])

  useEffect(() => {
    if (data) {
      // Filter out only packages with category "PREDEFINED"
      const fetchedPackageData = data?.getAllPackageAndFeturesList?.data || []
      // const predefinedPackages = fetchedPackageData.filter(
      //   (packageItem: any) => packageItem.package?.packageCategory === 'PREDEFINED'
      // )
      const filteredPackageData = fetchedPackageData.filter(
        (packageItem: any) => packageItem.package?.packageName
      )
      // setPackageData(predefinedPackages)
      setPackageData(filteredPackageData)
    }
  }, [data])

  if (error) {
    console.log(error)
  }
  if (loading) {
    return <LoadingSpinner />
  }

  if (loading1) {
    return <h4>Loading....</h4>
  }
  if (error1) {
    console.log(error1)
  }

  const accountData = data1?.getAllCurrentBillDetails?.currentMonthAllBillDetails || []
  const totalcount = data1?.getAllCurrentBillDetails?.countAllBillDetails || 0
  accountActionDropdownMenuRefs.current = accountData.map(
    (item: any, i: number) => accountActionDropdownMenuRefs?.current[i] ?? createRef()
  )
  console.log(accountData)

  const searchHandler = (value: any) => {
    let searchValue = value.trim()
    setSearchInput(searchValue)
  }

  const totalPages = Math.ceil(totalcount / accountPerPage)

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }

  const generatePaginationNumbers = () => {
    let numbers: number[] = []
    const maxVisibleNumbers = 5 // Maximum visible pagination numbers

    if (totalPages <= maxVisibleNumbers) {
      // If total pages are less than or equal to max visible numbers, show all
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i)
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2) // Middle index of the pagination numbers
      let startPage = currentPage - middleIndex + 1
      let endPage = currentPage + middleIndex - 1

      if (startPage < 1) {
        // If start page is less than 1, adjust start and end page accordingly
        endPage = startPage + maxVisibleNumbers - 1
        startPage = 1
      } else if (endPage > totalPages) {
        // If end page is greater than total pages, adjust start and end page accordingly
        startPage = endPage - maxVisibleNumbers + 1
        endPage = totalPages
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i)
      }
    }

    return numbers
  }
  console.log(accountData)
  return (
    <div className='card card-flush mt-6 mt-xl-9'>
      {/* Card header */}
      <div className='card-header mt-5 d-flex flex-column'>
        {/* Search bar and dropdown menu in the same line */}
        <div className='d-flex flex-row align-items-center mt-5'>
          {/* Status dropdown menu */}
          <div className='dropdown me-10'>
            <form className='row col mb-5'>
              <div className='col'>
                <label className='form-label fw-bolder text-dark fs-6'>Package Status:</label>
                <div className='position-relative mb-3'>
                  <select
                    className='form-select form-select-solid form-select w-auto'
                    name='Status'
                    onChange={(e) =>
                      handleStatusFilterChange(e.target.value !== 'Select' ? e.target.value : null)
                    }
                  >
                    <option key='blankKey' value='Select'>
                      All Select
                    </option>
                    <option value='ACTIVE'>Active</option>
                    <option value='INACTIVE'>Not Active</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          {/* Client package dropdown menu */}
          <div className='dropdown me-10'>
            <form className='row col mb-5'>
              <div className='col'>
                <label className='form-label fw-bolder text-dark fs-6'>Package Name:</label>
                <div className='position-relative mb-3'>
                  {/* <select
                    className='form-select form-select-solid form-select w-auto'
                    name='ClientPackage'
                    onChange={(e) =>
                      handleClientPackageChange(e.target.value !== 'Select' ? e.target.value : null)
                    }
                  >
                    <option key='blankKey' value='Select'>
                      All Select
                    </option>
                    {packageData?.map((packageItem: any, index: number) => (
                      <option
                        key={index}
                        value={packageItem?.package?.packageName}
                      >
                        {packageItem?.package?.packageName}
                      </option>
                    ))}
                  </select> */}
                  <select
                    className='form-select form-select-solid form-select w-auto'
                    name='ClientPackage'
                    onChange={(e) =>
                      handleClientPackageChange(e.target.value !== 'Select' ? e.target.value : null)
                    }
                  >
                    <option key='blankKey' value='Select'>
                      All Select
                    </option>

                    {/* Filter unique package names */}
                    {Array.from(
                      new Set(
                        packageData?.map((packageItem: any) => packageItem?.package?.packageName)
                      )
                    ).map((uniquePackageName, index) => (
                      <option key={uniquePackageName} value={uniquePackageName}>
                        {uniquePackageName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </form>
          </div>
          {/* Search bar */}
          <div className='col mx-5 position-relative'>
            <input
              type='text'
              className='form-control form-control-solid w-50'
              placeholder='Search by Invoice Number...'
              value={searchInput}
              onChange={(e) => searchHandler(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Card body */}
      <div className='card-body py-3'>
        <div className='card'>
          <div className='tab-content'>
            <div id='kt_billing_months' className='card-body p-0 tab-pane fade show active'>
              <div className='table-responsive'>
                <table className='table table-row-bordered align-middle gy-4 gs-9'>
                  <thead className='border-bottom border-gray-200 fs-6 fw-bold bg-light bg-opacity-75'>
                    <tr>
                      <td className='min-w-100px'>Invoice Number</td>
                      <td className='min-w-100px'>BG Account ID</td>
                      <td className='min-w-100px'>Name</td>
                      <td className='min-w-100px'>Email</td>
                      <td className='min-w-100px'>Client Package</td>
                      <td className='min-w-100px'>Package Status</td>
                      <td className='min-w-100px'>Start Date</td>
                      <td className='min-w-100px'>Expiry Date</td>
                      <td className='min-w-100px'>Package Amount</td>
                      <td className='min-w-100px'>Payment Remarks</td>
                      <td className='min-w-100px'>Send Notification</td>
                      <td className='min-w-100px'>Action</td>
                    </tr>
                  </thead>
                  <tbody className='fw-semibold text-gray-600'>
                    {accountData?.map((account: any, index: any) => {
                      const userName = account.clientPackage?.client?.users?.[0]?.name ?? 'N/A'
                      const userEmail = account.clientPackage?.client?.users?.[0]?.email ?? 'N/A'
                      const packageName =
                        account.clientPackage?.package?.package?.packageName ?? 'N/A'
                      const packageAmount =
                        account.clientPackage?.package?.package?.packageAmount ?? 'N/A'

                      return (
                        <tr key={account.billId}>
                          <td>{account.invoiceNumber || 'N/A'}</td>
                          <td>{account.bgAccountId || 'N/A'}</td>
                          <td>{userName}</td>
                          <td>{userEmail}</td>
                          <td>{packageName}</td>
                          <td>
                            <span
                              className={`badge  fw-semibold ${
                                account.packageStatus === 'ACTIVE'
                                  ? 'badge-light-success '
                                  : 'badge-light-danger'
                              } `}
                            >
                              {account.packageStatus}
                            </span>
                          </td>
                          <td>{account.planStartDate || 'N/A'}</td>
                          <td>{account.expiryDate || 'N/A'}</td>
                          <td>{packageAmount}</td>
                          <td>{account.paymentRemarks || 'N/A'}</td>
                          <td>
                            <button
                              className=''
                              onClick={() => openModal(account)}
                              style={{
                                color: '#ffffff',
                                backgroundColor: '#009ef7',
                                borderColor: 'transparent',
                                borderRadius: '0.475rem',
                                height: '35px'
                              }}
                            >
                              Send
                            </button>

                            <ReactModal
                              isOpen={isModalOpen}
                              // onAfterOpen={afterModal}
                              onRequestClose={closeModal}
                              style={customModalStyles}
                              contentLabel='Package Expiry Notification Modal'
                            >
                              <PackageExpiryNotificationModal
                                closeModal={closeModal}
                                accountData={selectedAccount}
                              />
                            </ReactModal>
                          </td>
                          <td ref={accountActionDropdownMenuRefs.current[index]}>
                            <AccountActionMenu
                              accountActionDropdownMenuRefs={accountActionDropdownMenuRefs}
                              user={account}
                              index={index}
                            />
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className='row m-2'>
                <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar'></div>
                <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                  <div className='dt-paging paging_simple_numbers'>
                    <div
                      className='dataTables_paginate paging_simple_numbers'
                      id='kt_table_users_paginate'
                    >
                      <ul className='pagination pb-2'>
                        <li
                          className={`paginate_button page-item ${
                            currentPage === 1 ? 'disabled' : ''
                          }`}
                        >
                          <button
                            type='button'
                            aria-controls='kt_table_users'
                            data-dt-idx='0'
                            className='btn primary page-link'
                            onClick={prevPage}
                          >
                            <i className='previous'></i>
                          </button>
                        </li>
                        {generatePaginationNumbers().map((pageNumber) => (
                          <li
                            key={pageNumber}
                            className={`paginate_button page-item ${
                              currentPage === pageNumber ? 'active' : ''
                            }`}
                          >
                            <button
                              type='button'
                              aria-controls='kt_table_users'
                              data-dt-idx={pageNumber}
                              className='btn primary page-link'
                              onClick={() => paginate(pageNumber)}
                              style={{ zIndex: '0' }}
                            >
                              {pageNumber}
                            </button>
                          </li>
                        ))}
                        <li
                          className={`paginate_button page-item ${
                            currentPage === totalPages ? 'disabled' : ''
                          }`}
                        >
                          <button
                            type='button'
                            aria-controls='kt_table_users'
                            data-dt-idx='0'
                            className='btn primary page-link'
                            onClick={nextPage}
                          >
                            <i className='next'></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Account
